import Search from '../Search';
import { Grid } from '../../../../../base-components';
import FilterComponent from '../Filters';
import { IFilterOption } from '../../../../table.interfaces';

interface ITopLeftActionsProps {
    filters: Array<IFilterOption>;
}
const TopLeftActions = (props: ITopLeftActionsProps) => {
    const { filters } = props;

    return (
        <>
            <Grid
                container
                direction={'row'}
                paddingInlineStart={2}
                alignItems="center"
                gap={3}
            >
                <Grid item display="flex" alignItems="center" height="64px">
                    <Search />
                </Grid>
                {filters.length > 0 && <FilterComponent filters={filters} />}
            </Grid>
        </>
    );
};

export default TopLeftActions;
